let prefix = "";

/* for prod only */
// let prefix = "/olympics"; 

export default prefix;